module.exports = __webpack_public_path__ + "57def18603f5a61b58110b9492b0c7b6.ttf";


//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/fonts/Alegreya-Regular.ttf
// module id = 8
// module chunks = 0